import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import PlayersView from 'views/players'; // Importing PlayersView component
import FilterFlujoCajaResumido from 'views/reports/flujoCajaResumidoMaquina/filterFlujoCajaResumido'; // Importing filter component for cash flow summary
import TableFlujoCajaResumido from 'views/reports/flujoCajaResumidoMaquina/tableFlujoCajaResumido'; // Importing table component for cash flow summary
import DetailsFlujoCajaResumido from 'views/reports/flujoCajaResumidoMaquina/detailsFlujoCajaResumido'; // Importing details component for cash flow summary
import RecordFlujoCajaResumido from 'views/reports/flujoCajaResumidoMaquina/recordFlujoCajaResumido'; // Importing record component for cash flow summary
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * SummaryCashFlowView class extends JetView to create a view for cash flow summary.
 */
export default class SummaryCashFlowView extends JetView {
    /**
     * Configures the UI components of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const theme = this.app.config.theme; // Current theme configuration
        const right = {
            type: 'wide',
            rows: [
                PlayersView, // Players view component
                DetailsFlujoCajaResumido, // Details view component
                RecordFlujoCajaResumido, // Record view component
            ],
        };
        const toolbar = {
            view: 'toolbar', // Toolbar component
            css: 'highlighted_header header6', // CSS classes for styling
            paddingX: 5, // Horizontal padding
            paddingY: 5, // Vertical padding
            height: 40, // Height of the toolbar
            cols: [
                {
                    view: 'pager', // Pager component for navigation
                    id: 'pagerA', // Unique identifier for the pager
                    template:
                        '{common.first()}{common.prev()}&nbsp; {common.pages()}&nbsp; {common.next()}{common.last()}', // Template for pager buttons
                    autosize: false, // Disable autosizing
                    height: 35, // Height of the pager
                    size: 1000000, // Maximum number of items to display
                },
                {
                    view: 'richselect', // Dropdown for export options
                    name: 'Export', // Name of the select
                    id: 'Export', // Unique identifier for the select
                    width: 120, // Width of the select
                    placeholder: _('Exportar'), // Placeholder text
                    options: [
                        // Options for export format
                        { id: '1', value: 'Excel' }, // Excel export option
                        { id: '2', value: 'PDF' }, // PDF export option
                    ],
                    on: {
                        onChange: function (value) {
                            // Event handler for change event
                            if (value == 1) {
                                // If Excel is selected
                                var table = $$('CashResume'); // Reference to the cash resume table
                                for (var j = 0; j < table.config.columns.length; j++) {
                                    if (table.config.columns[j].exportType) {
                                        delete table.config.columns[j].format; // Remove format for export
                                    }
                                }
                                this.app.callEvent('export:data', [
                                    // Trigger export event
                                    {
                                        NameReport:
                                            ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) +
                                            _('Flujo Caja Resumido Máquina'),
                                        TypeReport: 'Excel', // Specify report type
                                    },
                                ]);
                                webix.toExcel(table, {
                                    // Export to Excel
                                    docHeader: {
                                        text:
                                            _('Descripción del reporte: Flujo Caja Resumido ') +
                                            '\n' +
                                            _('Fecha de reporte: Desde ') +
                                            $$('Datepicker').getValue().substr(0, 10) +
                                            _(' Hasta ') +
                                            $$('Datepicker').getValue().substr(12, 20) +
                                            '\n' +
                                            _(' Fecha creación del reporte: ') +
                                            webix.Date.add(new Date(), -0, 'day').getFullYear() +
                                            '-' +
                                            ('00' + (webix.Date.add(new Date(), -0, 'day').getMonth() + 1)).slice(-2) +
                                            '-' +
                                            ('00' + webix.Date.add(new Date(), -0, 'day').getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + webix.Date.add(new Date(), -0, 'day').getHours()).slice(-2) +
                                            ':' +
                                            ('00' + webix.Date.add(new Date(), -0, 'day').getMinutes()).slice(-2),
                                        textAlign: 'right', // Align text to the right
                                    },
                                    filename:
                                        'Virtualsoft - ' +
                                        new Date()
                                            .toLocaleString('en-GB', {
                                                hour12: true,
                                            })
                                            .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                            .replace(/[\/:]/g, '_')
                                            .toUpperCase() +
                                        ' - ' +
                                        ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) +
                                        _('Flujo Caja Resumido Máquina'),
                                });
                            } else {
                                if (value == 2) {
                                    // If PDF is selected
                                    this.app.callEvent('export:data', [
                                        // Trigger export event
                                        {
                                            NameReport:
                                                ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) +
                                                _('Flujo Caja Resumido Máquina'),
                                            TypeReport: 'PDF', // Specify report type
                                        },
                                    ]);
                                    webix.toPDF($$('CashResume'), {
                                        // Export to PDF
                                        filename:
                                            'Virtualsoft - ' +
                                            new Date()
                                                .toLocaleString('en-GB', {
                                                    hour12: true,
                                                })
                                                .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                                .replace(/[\/:]/g, '_')
                                                .toUpperCase() +
                                            ' - ' +
                                            ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) +
                                            _('Flujo Caja Resumido Máquina'),
                                        autowidth: true, // Automatically adjust width
                                    });
                                }
                            }
                            $$('Export').setValue(''); // Reset export selection
                        }.bind(this), // Bind the context to the function
                    },
                },
            ],
        };
        const left = {
            css: 'int-left', // CSS class for left panel
            rows: [
                {
                    view: 'toolbar', // Toolbar for the left panel
                    css: theme, // Apply current theme
                    elements: [
                        {
                            view: 'label', // Label for the title
                            label: _('Flujo de Caja Resumido Máquina'),
                        },
                        {
                            type: 'wide',
                            css: 'close-bottom', // CSS class for close button
                            cols: [
                                {
                                    view: 'icon', // Icon for closing the view
                                    icon: 'wxi-close',
                                    bottom: 20,
                                    right: 35,
                                    width: 30,
                                    height: 30,
                                    click: () => this.show('/top/dashboard'), // Navigate to dashboard on click
                                },
                            ],
                        },
                    ],
                },
                FilterFlujoCajaResumido, // Filter component
                { id: 'res2', view: 'resizer' }, // Resizer for layout adjustment
                TableFlujoCajaResumido, // Table component for cash flow summary
                toolbar, // Toolbar component
            ],
        };
        webix.ui.fullScreen(); // Set the UI to full screen mode
        return {
            id: 'a5', // Unique identifier for the view
            type: 'clean', // Clean layout type
            view: 'form', // Form view
            scroll: 'y', // Enable vertical scrolling
            rows: [
                {
                    responsive: 'a5', // Responsive layout
                    type: 'wide',
                    cols: [
                        left, // Left panel configuration
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The grid component.
     */
    init(grid) {
        webix.ready(function () {
            // Wait for Webix to be ready
            if (screen.width < 500) {
                // Check screen width
                $$('res2').hide(); // Hide resizer on small screens
            }
        });
    }
}

// FILE DOCUMENTED
